import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const SecuredIcon = createSvgIcon(
  'SecuredIcon',
  <>
    <path
      d="M6.99935 9.99992H8.99935L8.61602 7.84992C8.83824 7.73881 9.01324 7.5777 9.14102 7.36658C9.26879 7.15547 9.33268 6.92214 9.33268 6.66658C9.33268 6.29992 9.20213 5.98603 8.94102 5.72492C8.6799 5.46381 8.36602 5.33325 7.99935 5.33325C7.63268 5.33325 7.31879 5.46381 7.05768 5.72492C6.79657 5.98603 6.66602 6.29992 6.66602 6.66658C6.66602 6.92214 6.7299 7.15547 6.85768 7.36658C6.98546 7.5777 7.16046 7.73881 7.38268 7.84992L6.99935 9.99992ZM7.99935 14.6666C6.4549 14.2777 5.1799 13.3916 4.17435 12.0083C3.16879 10.6249 2.66602 9.08881 2.66602 7.39992V3.33325L7.99935 1.33325L13.3327 3.33325V7.39992C13.3327 9.08881 12.8299 10.6249 11.8243 12.0083C10.8188 13.3916 9.54379 14.2777 7.99935 14.6666ZM7.99935 13.2666C9.1549 12.8999 10.1105 12.1666 10.866 11.0666C11.6216 9.96659 11.9993 8.74436 11.9993 7.39992V4.24992L7.99935 2.74992L3.99935 4.24992V7.39992C3.99935 8.74436 4.37713 9.96659 5.13268 11.0666C5.88824 12.1666 6.84379 12.8999 7.99935 13.2666Z"
      fill={ColorDynamic.Dark300}
    />
    <title>Secured</title>
  </>,
  {
    viewBox: '0 0 16 16',
    style: { width: '16px', height: '16px', fill: 'none' },
  },
);
